import { CapabiltyEnum } from '../../enums/capability';
import { injectable } from 'inversify';
import { JRAdapterOperationPattern } from '../urlEntity/operationPattern';
import { IDocumentMetadata } from '../../docManager';

@injectable()
export class JRAdapterDocumentMetadataUrlPattern extends JRAdapterOperationPattern {
    operationName = CapabiltyEnum.DOCUMENT_METADATA;
    async getUrl(nodeObj: IDocumentMetadata): Promise<string> {
        let baseUrl = await super.getUrl(nodeObj);

        baseUrl = baseUrl + '/' + nodeObj.docId;
        return baseUrl;
    }
}
